import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';

const ClientSelector = ({ baseOptions = null, selectedClient, setSelectedClient }) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Si baseOptions no es null, usarlo y evitar la petición
    if (baseOptions !== null) {
      setOptions(baseOptions);
      setIsLoading(false);
      return;
    }

    // Configuración del cancel token para axios
    const source = axios.CancelToken.source();

    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/maintenance/clients/`, { cancelToken: source.token })
      .then(response => {
        const data = response.data;
        console.log(data)
        // Mapear la data al formato esperado por SoftSelect
        const mappedOptions = data.map(option => ({
          label: option.nombre,
          value: option.id,
          ...option,
        }));
        setOptions(mappedOptions);
        setIsLoading(false);
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          console.log('Request canceled:', err.message);
        } else {
          setError(err.message);
          setIsLoading(false);
        }
      });

    // Cleanup: cancelar la petición si el componente se desmonta
    return () => {
      source.cancel('Operation canceled by the user.');
    };
  }, [baseOptions]);

  return (
    <SoftBox>
      <SoftTypography 
        variant="caption"
        fontWeight="bold"
        color="text"
      >
        Cliente
      </SoftTypography>
      <SoftSelect
        options={options}
        value={options.find(option => option.label === selectedClient)}
        onChange={setSelectedClient}
        isLoading={isLoading}
        placeholder="Seleccione un cliente"
        error={error}
      />
    </SoftBox>
  );
};

ClientSelector.propTypes = {
  baseOptions: PropTypes.array,
  selectedClient: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.string,
  ]),
  setSelectedClient: PropTypes.func.isRequired,
};

export default ClientSelector;
